import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { InputModule } from '../inputs/input.module';
import { PasswordComponent } from './components/password.component';

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,

        InputModule,
    ],
    declarations: [
        PasswordComponent,
    ],
    exports: [
        PasswordComponent,
    ],
})

export class PasswordModule {}
